import * as React from 'react';
import './StartNewAnsokan.scss';
import { SelectBoxOption, SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';
import { FormFieldString } from 'sos-common/js/commonTypes/formField.types';
import { InfoBlockModel } from '../../models/view.models';

export interface StartNewAnsokanProps {
  OccupationList: SelectBoxOption[];
  YrkesIds: Array<string>;
  Warning: InfoBlockModel;
  Info: string;
  ButtonLink: string;
  ButtonText: string;
  IsEditMode: boolean;
}

export interface StartNewAnsokanState {
  occupationList: SelectBoxOption[];
  selectedProfession: string;
  buttonLink: string;
}

export interface SelectBoxState extends FormFieldString {
  selectedText: string;
}
export class StartNewAnsokan extends React.Component<StartNewAnsokanProps, StartNewAnsokanState> {
  constructor(props: StartNewAnsokanProps) {
    super(props);
    this.state = {
      occupationList: props.OccupationList,
      selectedProfession: '',
      buttonLink: props.ButtonLink,
    };
  }

  render() {
    return (
      <>
        <SelectBox
          additionalAttributes={{ 'aria-labelledby': 'pickYrke' }}
          className="max25 start-new-ansokan__select"
          defaultOptionText={'Välj yrke'}
          options={this.state.occupationList}
          onChange={this.onChangeProfession}
          fieldName="pickYrke"
        />

        <div role="log" aria-live="polite">
          {this.hasAnsokan() && (
            <AttentionBox
              cssClass="start-new-ansokan__warning-text attentionbox--brown"
              icon="Infocirkel_normal20px20px"
              heading={this.props.Warning.Title}
              bodytext={this.props.Warning.Text}
            />
          )}
        </div>

        <div>{this.getButton()}</div>
        <div
          className="start-new-ansokan__information-text importantinfo"
          dangerouslySetInnerHTML={setInnerHtml(this.props.Info)}
        />
      </>
    );
  }

  onChangeProfession = (occupation: SelectBoxState) => {
    if (this.props.IsEditMode) return;
    this.setState({
      selectedProfession: occupation.value,
      buttonLink: this.props.ButtonLink + occupation.value,
    });
  };

  private hasAnsokan = () => {
    return this.props.YrkesIds.includes(this.state.selectedProfession);
  };

  private professionSelected = () => {
    return this.state.selectedProfession !== '';
  };

  private getButton = () => {
    if (!this.hasAnsokan() && this.professionSelected()) {
      return (
        <a className="start-new-ansokan__save-button button" href={this.state.buttonLink}>
          {this.props.ButtonText}
        </a>
      );
    }
    return <span className="start-new-ansokan__save-button button--disabled button">{this.props.ButtonText}</span>;
  };
}
